import {Area, AreaStyle, ZoneRecord} from "./Zones";
import polygonClipping from "polygon-clipping";
import ReactDOMServer from 'react-dom/server';
import {AreaBubbleIconLayout} from "./AreaBubbleIconLayout";

// @ts-ignore
export const showArea = (map: ymaps.Map, area: Area) => {
    let style = area.area_style;
    // @ts-ignore
    let polygon = new ymaps.Polygon([
        area.coords,
    ], {
        hintContent: ""
    }, {
        fillColor: style.fill_color,
        // Делаем полигон прозрачным для событий карты.
        interactivityModel: 'default#transparent',
        strokeWidth: style.stroke_width,
        strokeColor: style.stroke_color,
        opacity: style.fill_alpha
    });
    // polygonsMap.set(area["title"], polygon);
    map.geoObjects.add(polygon);
}

// @ts-ignore
export const showZone = (map: ymaps.Map, zone: ZoneRecord) => {
    let inverted: Array<Array<Array<number>>> = [];
    let style: AreaStyle;
    zone.areas.forEach(element => {
        if (element.area_style.inverted == true) {
            if (style == null) {
                style = element.area_style;
            }
            inverted.push(element.coords);
        } else {
            showArea(map, element);
        }

        var title = element.title
        var bubbleVisible = element.area_style.bubble_visible
        if (title != null && title.length !== 0 && bubbleVisible != null && bubbleVisible) {
            let bubbleColor;
            const styleColor = element.area_style.bubble_fill_color
            if (styleColor != null) {
                bubbleColor = styleColor;
            } else {
                bubbleColor = "#677dce";
            }

            var title = title.replace(/ /g, " ");

            var price = "";
            var fee = element.fee;
            if (fee != null) {
                price = " " + (fee / 100).toString() + " ₽"
            }

            addPlacemark(element["center"], title, price, bubbleColor, () => {
            }, map);
        }
    });

    if (inverted.length > 0) {
        let tmp: any[] = [];
        inverted.forEach(element => {
            // @ts-ignore
            tmp = polygonClipping.union(tmp, [element]);
        });

        let final = [[
            [85, -179.99],
            [85, 179.99],
            [-85, 179.99],
            [-85, -179.99],
            [85, -179.99]
        ]];

        tmp.forEach(el => {
            el.forEach((elEm: number[][]) => {
                final.push(elEm);
            });
        });

        // @ts-ignore
        let polygon = new ymaps.Polygon(final, {
            hintContent: ""
        }, {
            fillColor: style!.fill_color,
            // Делаем полигон прозрачным для событий карты.
            interactivityModel: 'default#transparent',
            strokeWidth: style!.stroke_width,
            strokeColor: style!.stroke_color,
            opacity: style!.fill_alpha,
            coordRendering: 'straightPath'
        });
        map.geoObjects.add(polygon);
    }
}

// @ts-ignore
function addPlacemark(coordinates, name, price, background, onClick, map) {
    // @ts-ignore
    let bubble = ymaps.templateLayoutFactory.createClass(
        ReactDOMServer.renderToString(AreaBubbleIconLayout()))
    // @ts-ignore
    // let layout = ymaps.templateLayoutFactory.createClass(
    //     '<div style="border: 2px double #ffffff7d; font-family: YS Text; font-size: 13px; font-weight: normal; display: inline-block; padding-right: 12px; padding-left: 12px; margin-left: -50px;  margin-top: -20px; border-radius: 10px; background: $[properties.background]; color: #ffffff";">$[properties.iconContent] <p style="display: inline; color: #ffffffb3; font-family: YS Text; font-size: 11pt;>$[properties.price]</p></div>',
    //     {
    //         // build: function () {
    //         //     // @ts-ignore
    //         //     layout.superclass.build.call(this);
    //         //     var bigShape = { type: 'Circle', coordinates: [0, -30], radius: 100 / 2 };
    //         //     this.getData().options.set('shape', bigShape);
    //         //     if (!this.inited) {
    //         //         this.inited = true;
    //         //         this.isActive = false;
    //         //         this.getData().geoObject.events.add('click', function () {
    //         //             onClick();
    //         //         }, this);
    //         //     }
    //         // }
    //     }
    // );
    // @ts-ignore
    let placemark = new ymaps.Placemark(
        coordinates,
        {
            iconContent: name,
            background: background,
            price: price
        },
        {
            // @ts-ignore
            iconContentLayout: bubble,
            iconImageSize: [100, 100],
            iconImageOffset: [-20, -20],
            iconLayout: 'default#imageWithContent',
            iconImageHref: ''
        }
    );

    // @ts-ignore
    placemark.events.add(['click'], (event) => {
        map.setCenter(coordinates, 18, {duration: 300});
        // let car = event.get('target').properties.get('car');

        // if (car?.id && !props.withoutTooltips && (props.carClickable ?? true)) {
        //     // @ts-ignore
        //     window.openAutoparkCar(car?.id);
        // }
    });

    // @ts-ignore
    map.geoObjects.add(placemark);
}